import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  readonly isDarkMode = signal(false);

  initThemeMode(): void {
    const storedMode = localStorage.getItem('themeMode');
    const shouldUseDark = storedMode
      ? storedMode === 'dark'
      : window.matchMedia('(prefers-color-scheme: dark)').matches;

    this.applyThemeMode(shouldUseDark);
  }

  toggleThemeMode(): void {
    const nextIsDark = !this.isDarkMode();
    this.isDarkMode.set(nextIsDark);
    localStorage.setItem('themeMode', nextIsDark ? 'dark' : 'light');
    this.applyThemeMode(nextIsDark);
  }

  private applyThemeMode(isDark: boolean): void {
    const rootElement = this.document.documentElement;
    rootElement.classList.toggle('dark-theme', isDark);
  }
}
